import React from "react";

const PrivateRoomsPerryOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="265.036"
      height="1038.693"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 265.036 1038.693"
      xmlSpace="preserve"
      className='clickable'
    >
      <clipPath id="ArtboardFrame">
        <path d="M0 0H2800V2160H0z"></path>
      </clipPath>
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinejoin="round"
        clipPath="url(#ArtboardFrame)"
        transform="translate(-2534.965 -740.325)"
      >
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2683 1012.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2728 1020.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2722 1035.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2718 1050.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2715 1064.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2712 1078.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2710 1093.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2708 1108.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2708 1122.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2708 1138.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2711 1151.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2679 1028.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2676 1043.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2672 1057.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2669 1071.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2666 1085.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2662 1101.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2659 1114.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2655 1129.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2650 1143.5a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2658 1003s-2.75 32.5-11 68-22 74-22 74"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2754 1024s-16.5 23.75-22 56 0 73 0 73"
          opacity="1"
        ></path>
        <path
          strokeLinecap="butt"
          strokeWidth="1"
          d="M2685 1013l45 9-49 7 40 22-47 7 41 21-46 6 42 23-49 7 49 23-58 6 61 8-56-22 53-8-46-21 47-7-41-22 46-7-39-21 46-8z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="3"
          d="M2690 1086s-8-7-12 1c-8.67 17.35-21.32 48.4-17 52 8.76 7.3 28-53 28-53s-22.86 72.97-6 70c17-3 7-66 7-66s-11.48 67.27 10 55c7-4-7-59-7-59s4.46 56.65 16 48c2.59-1.94-.41-27.69-6-43-1.07-2.94-3.12-7.3-5-8-3.48-1.29-7 3-7 3"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="5"
          d="M2623 986s45.5 2.75 82 9 63.31 17.94 63.31 17.94-5.43 17.79-11.67 29.42c-5.98 11.15-14.11 23.75-16.64 38.64-3.26 19.15 6.26 38.97 10 54 3.28 13.17 2 23 2 23l-42 2"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="5"
          d="M2615 1005s2.38 10.08 3.62 24.51c.84 9.92 3.4 20.87-.07 33.7-4.43 16.44-17.78 33.14-31.45 49.15-9.14 10.69-8.1 13.64-6.1 18.64 1.34 3.35 23 3 43 13 18.18 9.09 35 10 35 10"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2695 1005s-1.5 32-10 69-25 80-25 80"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2729 1011s-17 33-22 70 2 79 2 79"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="5"
          d="M2581 1132s-5 9.5-10 22-11 30-11 30 45 60 109 52c68 25 90-16 90-16s2.25-17.25 1-32-8-29-8-29"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2679 1183s.5 14.75-2 28-8 25-8 25"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2650 1273s7-18 6-24c-.92-5.51-4.4 2.76-5 6-1.08 5.82-.84 16.07-2 26-2.22 18.99-5.8 41.66-7 64-2.5 46.5 4.75 55 3 89-.42 8.24-7.55 25-9 47-1.32 20.11 3.22 44.78-1 68-10.2 56.15-29.97 110.78-29.97 110.78"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="3"
          d="M2605 1660s22.16-31.57 30-30c4.63.93 12.46 27.44 11.47 50.34-.08 1.81-.59 3.72-.94 5.45-1.7 8.23-4.15 18.26-7.71 28.31-2.29 6.48-5.15 13.26-7.38 19.81-2.29 6.77-4.49 13.75-5.9 19.27-2.08 8.17-3.86 14.3-4.9 15.49-.57.65-1.92.68-1.66-1.42.2-1.57 1.18-4.33 1.85-7.31 1.33-5.88 3.73-14.79 5.67-22.54 3.42-13.63 7.12-26.68 7.33-31.16.03-.52-.31-1.03-.48-1.19-1.52-1.42-4.25-1.64-6.17-.46-6.3 3.88-12.41 21.6-17.29 38.94-1.58 5.64-3.29 11.21-4.52 16.16-2.24 8.93-3.87 12.38-4.64 14.94-.32 1.05-.54 1.93-1.05 2.43-.35.36-.93.52-1.43.42-.76-.15-1.91-1.09-1.92-2.56-.04-4.54.72-6.25 2.94-15.68.8-3.38 2.05-7.09 2.85-10.88 1.58-7.37 3.37-15.45 4.26-22.97.63-5.27.95-10.72.85-14.99-.05-2.16-.19-5.1-.32-6.69-.24-3-.83-4.25-1.51-4.64-.45-.26-2.39-.59-3.15-.84-.44-.14.16 5.19-.2 14.64-.15 3.98-.91 9.15-1.81 14.09-.71 3.94-2.8 10.53-3.89 13.15-2.54 6.1-5.8 10.11-8.58 13.09-3.19 3.42-6.47 5.81-8.62 6.4-2.57.7-3.15-1.6-3.15-1.6s-1.27-1.91-1.32-5.17c-.05-2.94.63-6.66 2.99-15.8.27-1.06.74-2.82.6-4.34-.09-1.02-.53-1.86-.27-2.69 2.32-7.58 7.18-16.37 11-26 8.52-21.5 17-44 17-44z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2575 1758s5.25 4 10 6 11.44 2.88 11.44 2.88"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2602 1769s3.5 1.75 8 2 9-2 9-2"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="3"
          d="M2559 1185s-11.11 21.87-4.36 83.12c2.02 18.32 6.74 29.84 10 43.86 5.74 24.71 10.68 49.37 15.72 82.57 1.67 10.96 2.22 22.45 3.66 35.84 2.42 22.48 2.13 38.83 1.7 52.59-.48 15.3.16 28.08-.27 41.7-.19 5.87-.23 27.52.72 52.74.77 20.45 2.87 43.09 4.78 63.74 1.96 21.19.75 26.61-.43 33.09-.96 5.28-15.58 9.93-22.89 12.35-13.28 4.4-28.25 9.01-30.63 13.4-2.26 4.17 2.77 9.23 10.74 13.14 5.63 2.77 13.32 4.56 18.26 6.86 8.01 3.74 8.76 5.6 10.27 8.5"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="3"
          d="M2758 1225c-5 42-9.25 33.75-28 85s-36.25 69.25-47 120 5.25 39.75-2 96c-3.06 23.72-14.68 52.22-21 78-8.66 35.34-7 54-13 75"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="3"
          d="M2554 1267s-3.97-11.06-6.38-23.76c-1.73-9.16-1.75-20.07-4.08-29.76-2.13-8.82-3.29-13.82-4.06-19.08-.87-5.91-1.57-23.76-1.48-25.54.21-4.25-.57-18.02.37-32.18 1.64-24.88.4-54.14 3.72-68.55 1.36-5.92 6.3-18.75 9.08-27.3 5.49-16.85 10.07-28.39 19.83-58.83 9.65-30.113 15.65-64.669 29-81 4.32-5.287 10.68-8.63 18.5-11.646 8.2-3.162 16.85-6.439 24.91-6.892 3-.169 2.85 1.859 6.59 1.538 6.41-.551 16.8-4.352 20.54-7.139 5.62-4.2 9.56-11.977 8.39-20.785-1.51-11.33-7.76-23.235-7.76-23.235s-3.71 15.626-7.62 20.386c-.7.846-2.21 1.64-3.93 1.69-1.72.05-3.81-1.033-3.81-1.033s3.76-4.382 4.45-13.157c.24-3.025-.47-4.881-1.1-7.885-.76-3.64-.75-6.908-.06-8.996 1.21-3.62 2.79-2.666 3.9-6.214 1.11-3.549.05-5.304.54-7.981.43-2.352 2.83-4.588 3.77-7.09 3.59-9.537 3.07-20.382 6.98-28.176 1.3-2.58 2.59-1.512 2.92-5.285.12-1.351-2.13-3.493-1.1-6.111 1.39-3.518 16.16-10.865 36.12-17.958 8.99-3.197 27.67-4.31 30.39-1.917.79.685.22 1.682 2.63 2.408 2.41.727 3.71-1.33 6.66.682 1.73 1.18 2.35 3.584 3.4 5.109 1.96 2.859 4.03 5.313 8.02 9.546 4.09 4.348 8.41 7.879 9.12 8.819 1.78 2.343 4.85 5.995 4.62 7.279-1.12 6.3 1.95 9.821 1.95 9.821l-2.78-1.383-.13 2.788s1.81-.274 2.64.599c1.24 1.293 1.73 5.01 1.73 5.01l-3.06-.104s1.69 1.773.74 5.073c-1.76 6.141-6.54 15.676-8.6 19.541-2.79 5.217-9.41 8.233-9.71 11.674-.32 3.599 5.17 3.15 5.17 3.15s.13 3.345-.15 4.54c-.43 1.788-2.62 3.694-2.62 3.694l-1.55-6.934s-2.63.805-3.12 1.603c-1.71 2.842 1.28 5.032-1.12 10.693-2.41 5.661-8.3 12.951-8.3 12.951s2.46.924 3.71 2.999c.92 1.528.55 4.026-.31 4.709-2.01 1.611-7.51 1.904-7.51 1.904s1.69 3.044 1.86 6.036c.18 2.992-1.54 5.811-1.54 5.811s.54 2.263 4.41 5.52c2.35 1.98 6.61 3.918 10.8 7.124 4.62 3.53 14.38 7.574 19.26 12.38 3.32 3.272 5.81 8.036 7.78 12.683 11.94 28.16 13.74 69.661 13.74 69.661"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2623 970s2.52 15.138-7.49 34.55c-6.38 12.36-13.45 25.27-19.74 38.35-4.08 8.51-6.75 16.55-10.4 26.7-3.08 8.57-5.79 18.06-8.33 26.72-3.32 11.3-5.11 20.92-7.92 31.31-6.86 25.3-6.85 43.31-6.85 43.31"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2769 1012s9-11.25 15-23 9-24 9-24"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M2770.02 1011.1s2.38-.97 2.61 1.85c.69 8.64 2.18 27.95 2.92 49.41.53 15.25.84 31.73-.55 45.64-1.37 13.71-4.4 20.21-7 30.83-2.72 11.15-4.68 21.56-6.27 30.26-.85 4.69-2.23 6.79-2.23 6.79"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="3"
          d="M2727.58 1318.93s4.72.22 7.19-1.23c2.47-1.46.88-2.4 2.71-4.59 1.83-2.18 3.35-2 4.64-5.58 1.3-3.59.14-5.92.54-8.76 1.83-13.06 10.83-27.6 13.8-42 2.63-12.79 1.75-13.42 3.83-18.32 2.48-5.83 2.41-4.55 4.59-8.7 3.68-7.03 9.94-18.83 17.18-36.22 3.15-7.56 8.22-21.83 10.79-35.01 5.77-29.53 7.39-65.68 7.39-65.68"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default PrivateRoomsPerryOutline;